export class ElegibleForDiscount {
    byContract: Boolean = false;
    byCapacity: Boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/models/ElegibleForDiscount.model.ts